import { render, staticRenderFns } from "./CustomWheelEditor.vue?vue&type=template&id=4a26d2cf&scoped=true&"
import script from "./CustomWheelEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomWheelEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CustomWheelEditor.vue?vue&type=style&index=0&id=4a26d2cf&lang=scss&scoped=true&"
import style1 from "./CustomWheelEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a26d2cf",
  null
  
)

export default component.exports